import React, { useState } from "react";
import { EditableTextField,EditableSelectField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import OPTIONS from "../../../../constant/Option";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import { CustomSecondaryButton, CustomSuccessButton } from "../../../../Global_Component/GlobalButtonComponent";

const CompanyProfile = ({MoveToNextTab,MoveToPreviousTab}) => {
  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
   
        borderRadius: "8px",
        backgroundColor: "#fff",
       
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Company details
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={8}
        xl={9}
        spacing={0}
      >
       

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField name={"name"} label={"Company /Bussiness Name"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField isDate={true} name={"applicationDate"} label={"Application Date"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField multiline name={"address"} label={"Registered Office Address"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField multiline={true} name={"line"} label={"Line Address (optional)"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableSelectField name={"country"}  options={OPTIONS.state.getAllOptions().map((option)=>{return {value:option,label:option}})} label={"Country"} value={"India"} isEdit={true}/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableSelectField name={"state"} options={OPTIONS.state.getAllOptions().map((option)=>{return {value:option,label:option}})} label={"State"} value={"India"} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField name={"city"} label={"City"} value={""} isEdit={true}/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField name={"zipCode"} label={"Zip Code"} value={""} isEdit={true}/>
        </Grid>


        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField name={"websiteUrl"} label={"Website URL"} value={""} isEdit={true}/>
        </Grid>


        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField name={"PhoneNumber"} label={"Contact Number"} value={""} isEdit={true}/>
        </Grid>



       
      </Grid>

     <Grid xs={12} sx={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:1}}>
      <CustomSecondaryButton label={"Back"} sx={{margin:2}} onClick={e=>MoveToPreviousTab()}/>
        <CustomSuccessButton label={"Next"} onClick={e=>{MoveToNextTab()}}/>
     </Grid>
    </Box>
  );
};

export default CompanyProfile;
